module.exports = __webpack_public_path__ + "static/media/2702602.1b943d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2702602.png
// module id = ./src/assets/2702602.png
// module chunks = 2